import React from 'react';

import { Box, Typography } from '@mui/joy';
import { observer } from 'mobx-react-lite';

const GeoFenceEditor: React.FC = () => (
  <Box sx={{ p: 1 }}>
    <Typography level='body-sm'>GeoFence Editor (coming soon)</Typography>
  </Box>
);

export default observer(GeoFenceEditor);
